module.exports = __webpack_public_path__ + "static/media/LK_Cheveron_Up.7a52e863.svg";